// Short synthesized effects, activated only by an explicit player gesture.
export class GameAudio {
  private context: AudioContext | null = null;
  private master: GainNode | null = null;
  private noise: AudioBuffer | null = null;
  private voices = 0;
  private lastPlayed = new Map<string, number>();
  volume = .2;
  enabled = false;
  unlock() {
    if (!this.enabled) return;
    try {
      if (!this.context) {
        this.context = new AudioContext(); this.master = this.context.createGain(); this.master.connect(this.context.destination);
        this.noise = this.context.createBuffer(1, Math.ceil(this.context.sampleRate * .3), this.context.sampleRate);
        const data = this.noise.getChannelData(0);
        for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
      }
      if (this.context.state === 'suspended') void this.context.resume().catch(() => {});
    } catch { this.enabled = false; }
  }
  play(event: string) {
    if (!this.enabled || !this.context || !this.master || this.context.state !== 'running') return;
    const now = this.context.currentTime;
    // A crowded wave must not create unbounded audio nodes or a wall of warnings.
    if (this.voices >= 32 || now - (this.lastPlayed.get(event) ?? -1) < (event.includes('warning') ? .12 : .035)) return;
    const options: Record<string, [number, number, number, OscillatorType]> = {
      pistol: [180, 45, .09, 'square'], shotgun: [95, 25, .17, 'sawtooth'], gatling: [130, 35, .055, 'square'],
      hurt: [100, 45, .14, 'triangle'], pickup: [500, 1100, .13, 'sine'], kill: [400, 160, .06, 'triangle'],
      wave: [180, 500, .3, 'sine'], boss: [90, 35, .5, 'sawtooth'], clear: [400, 800, .25, 'sine'],
      door: [90, 160, .1, 'triangle'], 'enemy-shot': [550, 160, .14, 'sine'], dead: [160, 25, .5, 'triangle'],
      'melee-warning': [170, 250, .19, 'triangle'], 'shot-warning': [380, 700, .3, 'sine'],
      'charge-warning': [100, 350, .55, 'sawtooth'], charge: [190, 65, .25, 'sawtooth'],
      'boss-recovery': [220, 45, .3, 'triangle'], melee: [90, 40, .09, 'triangle'], empty: [800, 350, .04, 'square'],
    };
    const sound = options[event]; if (!sound) return;
    this.lastPlayed.set(event, now);
    const [start, end, length, type] = sound;
    const oscillator = this.context.createOscillator(), gain = this.context.createGain();
    this.master.gain.setValueAtTime(this.volume, now);
    oscillator.type = type; oscillator.frequency.setValueAtTime(start, now); oscillator.frequency.exponentialRampToValueAtTime(end, now + length);
    gain.gain.setValueAtTime(.0001, now); gain.gain.exponentialRampToValueAtTime(.18, now + .005); gain.gain.exponentialRampToValueAtTime(.0001, now + length);
    oscillator.connect(gain); gain.connect(this.master); oscillator.start(now); oscillator.stop(now + length + .01);
    this.voices++;
    oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); this.voices--; };
    const gun = event === 'pistol' || event === 'shotgun' || event === 'gatling';
    if (gun && this.noise) {
      const noise = this.context.createBufferSource(), filter = this.context.createBiquadFilter(), burst = this.context.createGain();
      noise.buffer = this.noise;
      filter.type = 'lowpass'; filter.frequency.setValueAtTime(event === 'shotgun' ? 1800 : 3200, now);
      filter.frequency.exponentialRampToValueAtTime(250, now + length);
      burst.gain.setValueAtTime(event === 'shotgun' ? .46 : .24, now);
      burst.gain.exponentialRampToValueAtTime(.0001, now + length);
      noise.connect(filter); filter.connect(burst); burst.connect(this.master);
      noise.start(now); noise.stop(now + length); this.voices++;
      noise.onended = () => { noise.disconnect(); filter.disconnect(); burst.disconnect(); this.voices--; };
    }
  }
}
